

export function useJSONEditor() {
 
  // 메뉴에서 숨길 항목들
  const handleRenderMenu = (items: any[]) => {
    return items.filter(item => {
      return item.type !== 'separator' &&
        item.text !== 'table' &&
        item.className !== 'jse-transform' &&
        item.className !== 'jse-search' &&
        item.className !== 'jse-sort'
    });
  };

  // 설정 메뉴에서 숨길 항목들
 const HIDDEN = ['Edit key','Edit array', 'Edit value', 'Edit object',
                'Convert to:', 'Structure',
                'Insert:',
                'Transform','Sort','Extract',
                'Insert before','Insert after'

 ];
  const isHidden = (item: any) =>
    HIDDEN.includes(item?.text) ||
    HIDDEN.includes(item?.title) ||
    HIDDEN.includes(item?.main?.text);
  const handleContextMenu = (items: any[]): any[] => {
    return items
      .filter(item => !isHidden(item))
      .map(item => {
        // row / column / dropdown-button 모두 안쪽에 items가 있음
        if (Array.isArray(item?.items)) {
          return { ...item, items: handleContextMenu(item.items) };
        }
        return item;
      });
  };

  return {
    handleRenderMenu,
    handleContextMenu
  }
}